import { ReactNode } from "react";
import I18n from "common/i18n";

type ProfileRowProps = {
  label: string;
  content: ReactNode;
  onEdit: () => void;
};

export const ProfileRow = ({ label, content, onEdit }: ProfileRowProps) => (
  <div className="flex-row-el items-center justify-between w-full py-4 px-6 bg-beige-20 rounded-xl">
    <div className="flex-row-el items-center gap-6">
      <p className="type-body text-textcolor-black w-[240px] shrink-0">{label}</p>
      <div className="flex-row-el items-center min-h-[40px]">{content}</div>
    </div>
    <div className="upsilon shrink-0 ml-4">
      <button className="btn btn-primary type-inherit-font !py-1 !px-3" onClick={onEdit}>
        <div className="flex-row-center gap-1">
          <span className="material-symbols-outlined type-body text-white">edit</span>
          <p className="type-text type-body text-white">{I18n.t("MSG_PROFILE_CHANGE_BTN")}</p>
        </div>
      </button>
    </div>
  </div>
);
